"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVolumeKg = exports.getClosestRelevantBodyWeightKgForDate = exports.estimatedWorkoutVolumeKg = exports.workoutVolumeKg = exports.isVolumeDoublingSupportableForExerciseTemplate = void 0;
const lodash_1 = require("lodash");
const _1 = require(".");
const isVolumeDoublingSupportableForExerciseTemplate = (exerciseTemplate) => {
    return (exerciseTemplate.equipment_category === 'dumbbell' &&
        exerciseTemplate.exercise_type === 'weight_reps');
};
exports.isVolumeDoublingSupportableForExerciseTemplate = isVolumeDoublingSupportableForExerciseTemplate;
const workoutVolumeKg = ({ workout, measurements, }) => {
    var _a, _b;
    const workoutDate = new Date(workout.start_time * 1000);
    /** We consider only measurements that include a body weight */
    const bodyWeightMeasurements = measurements.filter((m) => !!m.weight_kg);
    /** latest logged bodyweight that is older than the workout itself */
    const mostRecentMeasurementBeforeWorkout = (0, exports.getClosestRelevantBodyWeightKgForDate)(bodyWeightMeasurements, workoutDate);
    /**
     * there are no bodyweights logged *before* the workout, so take the oldest
     * logged bodyweight, even though it's newer than the workout, as that's the
     * closest approximation that we've got. if there is nothing logged at all,
     * then we have to take 0
     */
    const oldestLoggedMeasurement = (_b = (_a = bodyWeightMeasurements[0]) === null || _a === void 0 ? void 0 : _a.weight_kg) !== null && _b !== void 0 ? _b : 0;
    const bodyweightKg = mostRecentMeasurementBeforeWorkout !== null && mostRecentMeasurementBeforeWorkout !== void 0 ? mostRecentMeasurementBeforeWorkout : oldestLoggedMeasurement;
    return workoutVolumeSetsVolumeKg({
        bodyweightKg,
        sets: workoutToWorkoutVolumeSets(workout),
    });
};
exports.workoutVolumeKg = workoutVolumeKg;
const estimatedWorkoutVolumeKg = ({ workout, bodyweightKg, }) => {
    return workoutVolumeSetsVolumeKg({
        bodyweightKg,
        sets: workoutToWorkoutVolumeSets(workout),
    });
};
exports.estimatedWorkoutVolumeKg = estimatedWorkoutVolumeKg;
/**
 * Given a date, this will return the nearest bodyweight value
 * that was logged before it.
 */
const getClosestRelevantBodyWeightKgForDate = (bodyWeightMeasurements, date) => {
    var _a;
    return (_a = (0, _1.getClosestDataPointBeforeTargetDate)(bodyWeightMeasurements, (m) => new Date(m.date), date)) === null || _a === void 0 ? void 0 : _a.weight_kg;
};
exports.getClosestRelevantBodyWeightKgForDate = getClosestRelevantBodyWeightKgForDate;
const workoutVolumeSetsVolumeKg = ({ bodyweightKg, sets, }) => {
    return sets.reduce((accu, s) => {
        return accu + (0, exports.setVolumeKg)(s, bodyweightKg);
    }, 0);
};
const setVolumeKg = (set, bodyweightKg) => {
    const { type, weightKg: originalWeightKg, reps, distanceMeters, volumeDoublingEnabled, } = set;
    const weightKg = originalWeightKg * (volumeDoublingEnabled ? 2 : 1);
    switch (type) {
        case 'weight_reps':
            // eg. Bench Press (Barbell)
            return weightKg * reps;
        case 'reps_only':
            if (set.hundredPercentBodyweightExercise) {
                // eg. Pull Up
                return bodyweightKg * reps;
            }
            else {
                // eg. Push Up
                return 0;
            }
        case 'bodyweight_reps':
            if (set.hundredPercentBodyweightExercise) {
                // eg. Pull Up (Weighted)
                return (weightKg + bodyweightKg) * reps;
            }
            else {
                // eg. Push Up (Weighted)
                return weightKg * reps;
            }
        case 'bodyweight_assisted_reps':
            if (set.hundredPercentBodyweightExercise) {
                // eg. Pull Up (Assisted)
                const bodyweightAssistedRepsVolume = (bodyweightKg - weightKg) * reps;
                return Math.max(bodyweightAssistedRepsVolume, 0);
            }
            else {
                // e.g. a custom `bodyweight_assisted_reps` exercise
                return 0;
            }
        case 'short_distance_weight':
            // eg. Farmers Walk
            return distanceMeters * weightKg;
        case 'weight_duration':
            return weightKg;
        default:
            // `duration` and `distance_duration` exercises
            return 0;
    }
};
exports.setVolumeKg = setVolumeKg;
const workoutToWorkoutVolumeSets = (workout) => {
    const unflatSets = workout.exercises.map((e) => {
        return e.sets
            .filter((s) => workout.include_warmup_sets || s.indicator !== 'warmup')
            .map((s) => {
            var _a, _b, _c;
            return {
                type: e.exercise_type || 'weight_reps',
                exerciseTemplateId: e.exercise_template_id,
                weightKg: (_a = s.weight_kg) !== null && _a !== void 0 ? _a : 0,
                reps: (_b = s.reps) !== null && _b !== void 0 ? _b : 0,
                distanceMeters: (_c = s.distance_meters) !== null && _c !== void 0 ? _c : 0,
                volumeDoublingEnabled: e.volume_doubling_enabled,
                hundredPercentBodyweightExercise: e.hundred_percent_bodyweight_exercise,
            };
        });
    });
    const sets = (0, lodash_1.flatten)(unflatSets);
    return sets;
};
